/*
  Accessibility
*/
document.querySelectorAll('[data-nav-open], [data-nav-secondary-trigger="cart"]').forEach((el) => {

    const detailKey = el.hasAttribute('data-nav-secondary-trigger') ? 'menu' : el.getAttribute('data-nav-open')
    const detailEl = document.querySelector(`[data-nav-detail="${detailKey}"]`)
    el.addEventListener('click', (event) => {
        event.preventDefault()
        if (el.hasAttribute('data-nav-secondary-trigger')) {
            const ogMenuOpen = document.querySelector(`[data-nav-open="${detailKey}"]`)
            ogMenuOpen.classList.remove('active');
            ogMenuOpen.setAttribute('aria-expanded', 'false')
            detailEl.setAttribute('aria-hidden', 'true')
            return
        }

        if (detailEl.getAttribute('aria-hidden') === 'false') {
            event.currentTarget.setAttribute('aria-expanded', 'false');
            detailEl.setAttribute('aria-hidden', 'true')
            removeTrapFocus(el)
            el.classList.remove('active');
            document.body.removeAttribute('style');
        } else {
            el.classList.add('active');
            document.body.style.overflow = 'hidden';
            event.currentTarget.setAttribute('aria-expanded', 'true');
            detailEl.setAttribute('aria-hidden', 'false')
            trapFocus(detailEl)
        }
    });

    detailEl.parentElement.addEventListener('keyup', onKeyUpEscape);
});

function getFocusableElements(container) {
    const devicePixelRatio = window.devicePixelRatio ?? 2
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    ).filter((el) => {
        const targetSize = (
            el.getBoundingClientRect().width * devicePixelRatio
        ).toFixed(0)
        return !(targetSize === '0' || targetSize === '');
    });
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocusConcrete = undefined) {
    let elements = getFocusableElements(container);
    let first = elements[0];
    let last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) {
            return;
        }
        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function (event) {
        if (container.contains(event.target)) {
            return
        }
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return;
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    const elementToFocus = elementToFocusConcrete ?? first

    elementToFocus.focus();

    if (
        elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value
    ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }

    // hate this but works fine - ensures focus in cart
    window.setTimeout(() => {
        elementToFocus.focus();
    }, 100)
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const cart = document.querySelector("site-cart");
    const cartDetail = document.querySelector('#cartDetail')
    let opener = undefined
    if (cart && cartDetail.getAttribute('aria-hidden') === 'false') {
        cart.toggleCart();
        opener = document.querySelector(`[data-nav-open="cart"]`)
    } else {
        const openDetailsElement = event.target.closest('[data-nav-detail][aria-hidden="false"]');
        if (!openDetailsElement) return;
        const detailKey = openDetailsElement.getAttribute('data-nav-detail')
        opener = document.querySelector(`[data-nav-open="${detailKey}"]`)
        openDetailsElement.setAttribute('aria-hidden', 'true')
    }

    opener.setAttribute('aria-expanded', 'false');
    opener.focus();
    opener.classList.remove('active')
}

/*
Site Video
*/

class SiteVideo extends HTMLElement {
    constructor() {
        super();
        this.video = null;
    }

    connectedCallback() {
        this.video = this.querySelector("video");
        this.observe();
    }

    observe() {
        if ("IntersectionObserver" in window) {
            const videoObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(function (video) {
                    const $video = video.target;
                    if (video.isIntersecting) {
                        if ($video.readyState === 4) {
                            $video.play();
                        } else {
                            [].slice
                                .call($video.querySelectorAll("source"))
                                .forEach((source) => {
                                    source.src = source.dataset.src;
                                });
                            $video.load();
                        }
                    } else {
                        if (!$video.paused) {
                            $video.pause();
                        }
                    }
                });
            });

            videoObserver.observe(this.video);
        }
    }

    play() {
        this.video.play();
    }

    pause() {
        this.video.pause();
    }
}

customElements.define("site-video", SiteVideo);

/*
Site Image
*/

class SiteImage extends HTMLElement {
    constructor() {
        super();
        this.observe();
    }

    observe() {
        if ("IntersectionObserver" in window) {
            const imageObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(function (image) {
                    const $image = image.target;
                    if (image.isIntersecting) {
                        $image.classList.add("active");
                        imageObserver.unobserve($image);
                    }
                });
            });

            imageObserver.observe(this.querySelector(".mediabox"));
        }
    }
}

customElements.define("site-image", SiteImage);

/*
Carousel Prev
*/

class CarouselPrev extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        if (!this.querySelector("button")) {
            console.warn("You need to have a child button to go to previous!");
        }

        this.addEventListener("click", (e) => {
            const carousel = e.target.closest("site-carousel");

            if (carousel) {
                carousel.previous();
            } else {
                console.error("<carousel-prev> needs to be a child of <site-carousel>");
            }
        });
    }
}

customElements.define("carousel-prev", CarouselPrev);

/*
Carousel Next
*/

class CarouselNext extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        if (!this.querySelector("button")) {
            console.warn("You need to have a child button to go to next!");
        }

        this.addEventListener("click", (e) => {
            const carousel = e.target.closest("site-carousel");

            if (carousel) {
                carousel.next();
            } else {
                console.error("<carousel-next> needs to be a child of <site-carousel>");
            }
        });
    }
}

customElements.define("carousel-next", CarouselNext);

/*
Carousel Pager
*/

class CarouselPager extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const pagerButtons = Array.from(this.querySelectorAll("button"));

        if (!pagerButtons.length > 1) {
            console.warn("No need for a pager with only one item!");
        }

        pagerButtons.forEach((pager, i) => {
            pager.addEventListener("click", (e) => {
                const carousel = e.target.closest("site-carousel");

                if (carousel) {
                    carousel.slideTo(i);
                } else {
                    console.error(
                        "<carousel-pager> needs to be a child of <site-carousel>"
                    );
                }
            });
        });
    }
}

customElements.define("carousel-pager", CarouselPager);

/*
 * Site Carousel
 */

class SiteCarousel extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
    }

    connectedCallback() {
        const config = this.dataset.config
            ? JSON.parse(this.dataset.config)
            : {slidesPerView: 3, spaceBetween: 20};

        this.swiper = new Swiper(`#${this.dataset.id} .swiper`, config);
        this.handleSlideChange();
    }

    previous() {
        if (this.swiper) {
            this.swiper.slidePrev();
        }
    }

    next() {
        if (this.swiper) {
            this.swiper.slideNext();
        }
    }

    slideTo(i) {
        if (this.swiper) {
            this.swiper.slideTo(i);
        }
    }

    handleSlideChange() {
        // we can have multiple pagers in one carousel
        const pagers = Array.from(this.querySelectorAll("carousel-pager"));

        if (this.swiper) {
            this.swiper.on("slideChange", () => {
                pagers.forEach((pager) => {
                    const buttons = Array.from(pager.querySelectorAll("button"));
                    const nextPager = buttons[this.swiper.realIndex];

                    buttons.forEach((button) => button.classList.remove("active"));
                    nextPager.classList.add("active");
                });
            });
        }
    }
}

customElements.define("site-carousel", SiteCarousel);

class OkendoStars extends HTMLElement {
    connectedCallback() {
        this.productId = this.dataset.productId;
        this.fetchOkendoReviewData();
    }

    async fetchOkendoReviewData() {
        const okendoUserId = "8e34414f-e086-4a1a-ac86-923843f0aefe";
        const ratingReviewSpan = this.querySelector(`.js-rating-and-review`);
        const ratingFieldset = this.querySelector(`#js-rating-${this.productId}`);

        try {
            const response = await fetch(
                `https://api.okendo.io/v1/stores/${okendoUserId}/products/shopify-${this.productId}/review_aggregate`
            );
            const reviewData = await response.json();

            if (response.ok) {
                let ratingReviewCount = reviewData.reviewAggregate.ratingAndReviewCount;
                let ratingReviewValueTotal =
                    reviewData.reviewAggregate.ratingAndReviewValuesTotal;
                const rating = ratingReviewValueTotal / ratingReviewCount;
                ratingReviewSpan.innerHTML = `${rating.toFixed(
                    1
                )}  Based on ${ratingReviewCount} ${
                    ratingReviewCount == 1 ? "review" : "reviews"
                }`;

                if (ratingFieldset) {
                    const ratingInput = ratingFieldset.querySelector(
                        `#star${Math.round(rating)}`
                    );
                    ratingInput.checked = true;
                }
            }
        } catch (error) {
            console.error("Error fetching Okendo review data:", error);
        }
    }
}

customElements.define("okendo-stars", OkendoStars);

/*
Newsletter Popup Signup
*/

class NewsletterPopupSignup extends HTMLElement {
    connectedCallback() {
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", (e) => {
            e.preventDefault();
            this.submitForm(e);
        });
    }

    async submitForm(e) {
        const email = this.querySelector("[type='email']");
        const age = this.querySelector("[name='age']");
        const pref = Array.from(
            this.querySelectorAll("[name='email-preference']")
        ).find((radio) => radio.checked);

        const submit = this.form.querySelector('[type="submit"]');
        const uri = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
        const body = new URLSearchParams({
            email: email.value,
            $fields: "$age, $emailPreference",
            $age: age.value,
            $emailPreference: pref.value,
            g: "WEBLUN",
        });

        submit.innerHTML = "Submitting...";

        const res = await fetch(uri, {method: "POST", body: body});
        const data = await res.json();
        if (data.success) {
            this.form
                .closest("newsletter-popup-signup")
                .querySelector(".hidden")
                .classList.remove("hidden");
            this.form.classList.add("hidden");
        }
    }
}

customElements.define("newsletter-popup-signup", NewsletterPopupSignup);

/*
Newsletter Footer Signup
*/

class NewsletterFooterSignup extends HTMLElement {
    connectedCallback() {
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", (e) => {
            e.preventDefault();
            this.submitForm(e);
        });
    }

    async submitForm(e) {
        const submit = this.form.querySelector('[type="submit"]');
        const uri = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
        const body = new URLSearchParams({
            email: this.querySelector(".js-email-input").value,
            g: "WEBLUN",
        });

        submit.innerHTML = "Submitting...";

        const res = await fetch(uri, {method: "POST", body: body});
        const data = await res.json();
        if (data.success) {
            this.form
                .closest("newsletter-footer-signup")
                .querySelector(".hidden")
                .classList.remove("hidden");
            this.form.classList.add("hidden");
        }
    }
}

customElements.define("newsletter-footer-signup", NewsletterFooterSignup);

/*
Send Hint
*/

class SendHint extends HTMLElement {
    connectedCallback() {
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", (e) => {
            e.preventDefault();
            this.submitForm();
        });
    }

    async submitForm() {
        const submit = this.form.querySelector('[type="submit"]');
        const email = this.querySelector("[name='email']");
        const name = this.querySelector("[name='name']");
        const subject = this.querySelector("[name='subject']");
        const message = this.querySelector("[name='message']");
        const uri = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
        const body = new URLSearchParams({
            $fields: "$first_name, Send Hint Subject, Send Hint Message",
            email: email.value,
            $first_name: name.value,
            "Send Hint Subject": subject.value,
            "Send Hint Message": message.value,
            g: "RuJTgb",
        });

        submit.innerHTML = "sending...";

        const res = await fetch(uri, {method: "POST", body: body});
        const data = await res.json();
        if (data.success) {
            this.form
                .closest("send-hint")
                .querySelector(".hidden")
                .classList.remove("hidden");
            this.form.querySelector(".js-title").classList.add("hidden");
            this.form.querySelector(".js-subtitle").classList.add("hidden");
            this.form.querySelector(".js-form-fields").classList.add("hidden");
            this.form.querySelector(".js-disclaimer").classList.add("hidden");
        }
    }
}

customElements.define("send-hint", SendHint);

/*
FAQs
*/

class Faqs extends HTMLElement {
    constructor() {
        super();
        this.renderAnswer();
    }

    renderAnswer() {
        const arrow = this.querySelector("svg");
        const trigger = this.querySelector("button");
        const container = this.querySelector(".accordion-item");
        const content = this.querySelector(".accordion-content");

        trigger.addEventListener("click", () => {
            container.classList.toggle("active");

            if (container.classList.contains("active")) {
                content.style.maxHeight = content.scrollHeight + "px";
            } else {
                content.style.maxHeight = "0";
            }
        });
    }
}

customElements.define("question-answer", Faqs);

/*
Site Modal
*/

class SiteModal extends HTMLElement {
    constructor() {
        super();
        this.autoOpenTimeout = this.dataset.autoOpenTimeout;
    }

    openModal() {
        this.querySelector(".modal").classList.add("active");

        const video = this.querySelector("site-video");
        if (video) {
            video.play();
        }
    }

    closeModal() {
        this.querySelector(".modal").classList.remove("active");

        if (this.autoOpenTimeout) {
            localStorage.setItem("newsletter", "true");
        }

        const video = this.querySelector("site-video");
        if (video) {
            video.pause();
        }
    }

    connectedCallback() {
        const opens = this.querySelectorAll(".modal-open");
        const closes = this.querySelectorAll(".modal-close");
        const triggerClass = this.dataset.trigger;
        const trigger = document.querySelector(triggerClass);

        if (trigger) {
            trigger.addEventListener("click", (e) => {
                this.openModal();
            });
        }

        Array.from(opens).forEach((open) => {
            open.addEventListener("click", (e) => {
                this.openModal();
            });
        });

        Array.from(closes).forEach((close) => {
            close.addEventListener("click", (e) => {
                this.closeModal();
            });
        });

        if (this.autoOpenTimeout) {
            setTimeout(() => {
                if (!localStorage.getItem("newsletter")) {
                    this.openModal();
                }
            }, this.autoOpenTimeout);
        }
    }
}

customElements.define("site-modal", SiteModal);

/*
Number Input
*/

class NumberInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", {bubbles: true});

        this.querySelectorAll("button").forEach((button) =>
            button.addEventListener("click", this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        const button = event.target.closest("button");

        if (button) {
            button.name === "increment" ? this.input.stepUp() : this.input.stepDown();

            if (previousValue !== this.input.value) {
                this.input.dispatchEvent(this.changeEvent);
            }
        }
    }
}

customElements.define("number-input", NumberInput);

/*
Select Input
*/

class SelectInput extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const target = this.querySelector(".select-target");
        const targetText = target.innerHTML;

        this.querySelector("select").addEventListener("change", (e) => {
            const options = Array.from(this.querySelectorAll("option"));
            const active = options.find((o) => o.value === e.target.value);

            if (!!e.target.value) {
                target.innerHTML = active.innerHTML;
                target.classList.add("text-vella-velvet");
            } else {
                target.innerHTML = targetText;
                target.classList.remove("text-vella-velvet");
            }
        });
    }
}

customElements.define("select-input", SelectInput);

/*
Cart Toggle
*/

class CartToggle extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        if (!this.querySelector("button")) {
            console.warn("Cart toggle component should have a button as a child!");
        }

        this.addEventListener("click", (e) => {
            const cart = document.querySelector("site-cart");
            if (cart) {
                cart.toggleCart();
            }
        });
    }
}

customElements.define("cart-toggle", CartToggle);

/*
Cart Add
*/

class CartAdd extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const denoms = Array.from(this.querySelectorAll(".gift-card-variant"));
        if (denoms.length > 0) {
            denoms.forEach((denom) => {
                denom.addEventListener("click", (e) => {
                    const $price = this.querySelector(".product-price");
                    const price = e.target.innerHTML;
                    const $id = this.querySelector('[name="id"]');
                    const id = e.target.dataset.variantId;

                    $id.value = id;
                    $price.innerHTML = price;

                    denoms.forEach((d) => d.classList.remove("border-vella-velvet"));
                    e.target.classList.add("border-vella-velvet");
                });
            });
        }

        this.querySelector("form").addEventListener("submit", async (e) => {
            e.preventDefault();

            const $id = e.target.querySelector('[name="id"]');
            const $qty = e.target.querySelector('[name="quantity"]');
            const $sellingPlan = e.target.querySelector('[name="selling_plan"]');
            const qty = $qty ? $qty.value : 1;
            const sellingPlan =
                $sellingPlan && !!$sellingPlan.value ? $sellingPlan.value : null;

            if ($id) {
                const cart = document.querySelector("site-cart");
                if (cart) {
                    await cart.addVariantToCart($id.value, qty, sellingPlan);
                }
            }
        });
    }
}

customElements.define("cart-add", CartAdd);

/*
Cart Update
*/

class CartUpdate extends HTMLElement {
    constructor() {
        super();
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }

    connectedCallback() {
        this.addEventListener(
            "change",
            this.debounce(async (e) => {
                const cart = document.querySelector("site-cart");
                const idx = e.target.dataset.index;
                const val = e.target.value;

                if (cart) {
                    await cart.updateQuantity(idx, val);
                }
            }, 300)
        );
    }
}

customElements.define("cart-update", CartUpdate);

/*
Site Cart
*/

class SiteCart extends HTMLElement {
    constructor() {
        super();
        this.cart = null;
    }

    connectedCallback() {
        this.cart = document.querySelector(".site-cart");
    }

    openCart() {
        if (this.cart) {
            this.cart.classList.add("active");
            document.body.style.overflow = "hidden";
            trapFocus(document.querySelector('[data-nav-detail="cart"]'))
            document.querySelector('[data-nav-detail="cart"]').setAttribute('aria-hidden', 'false')
        }
    }

    closeCart() {
        if (this.cart) {
            this.cart.classList.remove("active");
            document.body.removeAttribute("style");
            removeTrapFocus(document.querySelector('[data-nav-open="cart"]'))
            document.querySelector('[data-nav-detail="cart"]').setAttribute('aria-hidden', 'true')
        }
    }

    toggleCart() {
        if (this.cart.classList.contains("active")) {
            this.closeCart();
        } else {
            this.openCart();
        }
    }

    getCartSections() {
        return [
            {
                section: "main-cart-items",
                selector: "#main-cart-items",
            },
            {
                section: "main-cart-footer",
                selector: "#main-cart-footer",
            },
            {
                section: "main-cart-header",
                selector: "#main-cart-header",
            },
            {
                section: "cart-icon-bubble",
                selector: "#cart-icon-bubble",
            },
            {
                section: "main-cart-nav",
                selector: "#main-cart-nav",
            },
        ];
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
    }

    renderCartSections(sections) {
        const getSections = this.getCartSections();
        const sectionsArr = Object.keys(sections);

        sectionsArr.forEach((sectionKey) => {
            const activeSection = getSections.find((s) => s.section === sectionKey);
            const elToReplace = document.querySelector(activeSection.selector);
            if (elToReplace) {
                elToReplace.innerHTML = this.getSectionInnerHTML(
                    sections[sectionKey],
                    activeSection.selector
                );
            }
        });

        window.setTimeout(() => {
            trapFocus(document.querySelector('[data-nav-detail="cart"]'))
        }, 100)
    }

    buildConfig(body) {
        return {
            body: body,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: `application/json`,
            },
        };
    }

    addVariantToCart(id, quantity = 1, sellingPlan) {
        const items = [
            sellingPlan
                ? {id, quantity, selling_plan: sellingPlan}
                : {id, quantity},
        ];
        const sections = this.getCartSections().map((s) => s.section);
        const body = JSON.stringify({items, sections});
        const config = this.buildConfig(body);

        this.toggleCart();

        return fetch(`/cart/add`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    this.handleErrorMessage(response.description);
                    return;
                }

                this.renderCartSections(response.sections);
            })
            .catch((e) => {
                // handle error
            });
    }

    updateQuantity(line, quantity) {
        const items = document.querySelectorAll("#main-cart-items li");
        const sections = this.getCartSections().map((s) => s.section);
        const body = JSON.stringify({line, quantity, sections});
        const config = this.buildConfig(body);
        const item = items[line - 1];
        const price = item.querySelector(".cart-price");
        const loader = item.querySelector(".cart-loader");

        price.classList.add("hidden");
        loader.classList.remove("hidden");

        return fetch("/cart/change", config)
            .then((response) => response.json())
            .then((response) => {
                price.classList.remove("hidden");
                loader.classList.add("hidden");

                this.renderCartSections(response.sections);
            })
            .catch(() => {
                // handle error
            });
    }
}

customElements.define("site-cart", SiteCart);

/*
Site Marquee
*/

class SiteMarquee extends HTMLElement {
    constructor() {
        super();
        const duration = this.dataset.duration;
        const shadowRoot = this.attachShadow({mode: "open"});
        shadowRoot.innerHTML = this.getInnerHTML();

        const width = this.querySelector('[slot="content"]').scrollWidth / 5;
        shadowRoot.innerHTML = this.getInnerHTML(width, duration);
    }

    getInnerHTML(width = 0, duration = "20s") {
        return `
      <style>
        ::slotted([slot="content"]) {
          display: grid;
          grid-auto-flow: column;
          align-items: center;
          height: 100%;
        }
        .marquee-list {
          display: grid;
          grid-auto-flow: column;
          align-items: center;
          white-space: nowrap;
          animation: marquee ${duration} linear infinite;
          height: 100%;
        }

        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-${width}px);
          }
        }
      </style>
      <div class="marquee-cont">
        <div class="marquee-list">
          <slot name="content"></slot>
        </div>
      </div>
    `;
    }
}

customElements.define("site-marquee", SiteMarquee);

/*
Consortium Signup
*/

class ConsortiumSignup extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector("form");
    }

    connectedCallback() {
        this.form.addEventListener("submit", (e) => {
            e.preventDefault();
            this.handleSubmit();
        });

        const radios = Array.from(this.querySelectorAll('input[type="radio"]'));
        radios.forEach((radio) => {
            const practiceName = this.form.querySelector('[name="practice_name"]');
            const practiceWebsite = this.form.querySelector(
                '[name="practice_website"]'
            );
            const namePh = practiceName.getAttribute("placeholder");
            const websitePh = practiceWebsite.getAttribute("placeholder");

            radio.addEventListener("change", (e) => {
                practiceName.required = e.target.value === "yes" ? true : false;
                practiceWebsite.required = e.target.value === "yes" ? true : false;

                practiceName.setAttribute(
                    "placeholder",
                    e.target.value === "yes" ? `${namePh}*` : namePh
                );
                practiceWebsite.setAttribute(
                    "placeholder",
                    e.target.value === "yes" ? `${websitePh}*` : websitePh
                );
            });
        });
    }

    async handleSubmit() {
        const submit = this.querySelector('[type="submit"]');
        const submitText = submit.innerHTML;
        const formData = new FormData(this.form);
        const formDataObj = {};
        formData.forEach(function (value, key) {
            formDataObj[key] = value;
        });

        submit.innerHTML = "submitting...";

        try {
            const signup = await fetch(
                "https://vella-next.vercel.app/api/vella/consortium-signup",
                {
                    method: "POST",
                    body: JSON.stringify(formDataObj),
                }
            );
            const resp = await signup.json();
            this.querySelector(".hidden").classList.remove("hidden");
            this.form.classList.add("hidden");
        } catch (e) {
            console.log(e.message);
        }

        submit.innerHTML = submitText;
    }
}

customElements.define("consortium-signup", ConsortiumSignup);

/*
Notify Me
*/

class NotifyMe extends HTMLElement {
    connectedCallback() {
        this.form = this.querySelector("form");
        this.submit = this.form.querySelector('[type="submit"]');
        this.success = this.querySelector(".success");
        this.companyId = this.getAttribute('data-company-id')
        this.form.addEventListener("submit", this.submitForm.bind(this));
    }

    async submitForm(e) {
        e.preventDefault()
        this.renderLoading()

        const data = {
            email: this.querySelector("[type='email']").value,
            variant: this.form.dataset.variantId,
        }

        const config = {
            method: 'POST',
            headers: {
                accept: 'application/json',
                revision: '2024-02-15',
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                data: {
                    type: 'back-in-stock-subscription',
                    attributes: {
                        channels: ['EMAIL'],
                        profile: {
                            data: {type: 'profile', attributes: {email: data.email}},
                            email: data.email
                        }
                    },
                    relationships: {
                        variant: {
                            data: {
                                type: 'catalog-variant',
                                id: `$shopify:::$default:::${this.form.dataset.variantId}`
                            }
                        }
                    }
                }
            })
        }

        fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${this.companyId}`, config)
            .then((response) => response.text())
            .then((response) => {
                if (response?.length) {
                    this.renderError()
                    return
                }
                this.renderSuccess()
            })
            .catch((e) => {
                this.renderError()
                console.error(e)
            })
            .finally(() => {

            })
    }

    renderSuccess() {
        this.form.classList.add("hidden");
        this.success.classList.remove("hidden");
        this.submit.innerHTML = 'Success'
        this.success.innerHTML = 'Success! You’ll receive an email when this product comes back in stock.'
    }

    renderError() {
        this.success.classList.remove("hidden");
        this.success.innerHTML = 'Please double check your email address and try again.'
        this.submit.innerHTML = 'Submit'
    }

    renderLoading() {
        this.submit.innerHTML = "Submitting...";
        this.success.classList.add("hidden");
        this.success.innerHTML = ''
    }
}

customElements.define("notify-me", NotifyMe);

/* DynamicGWP */

class DynamicGWP extends HTMLElement {
    constructor() {
        super()
        this.variantId = this.getAttribute('data-gwp-id')
        this.action = this.getAttribute('data-gwp-action')
        this.removeButton = this.querySelector('button[data-remove-disable]')
        this.removeButton?.addEventListener('click', this.removeAndDisable.bind(this))
    }

    connectedCallback() {
        let updates = {
            [this.variantId]: undefined
        }
        if (this.action === 'ADD') {
            updates[this.variantId] = 1
            void this.update(updates)
        }
        if (this.action === 'REMOVE') {
            updates[this.variantId] = 0
            void this.update(updates)
        }
        if (this.action === 'CORRECT') {
            updates[this.variantId] = 1
            void this.update(updates)
        }
    }

    async update(updates, attributes = undefined) {
        const cart = document.querySelector('site-cart')
        const sections = cart.getCartSections().map((s) => s.section);
        const body = attributes ? JSON.stringify({updates, sections, attributes}) : JSON.stringify({updates, sections})

        fetch(`/cart/update.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body,
        }).then((response) => response.json()).then(response => {
            cart.renderCartSections(response.sections);
        })
    }

    async removeAndDisable() {
        const attributes = {
            '_gwp_decline': 'true'
        }
        const updates = {
            [this.variantId]: 0
        }
        void this.update(updates, attributes)
    }
}

customElements.define('dynamic-gwp', DynamicGWP)
